import { HttpClient } from '@angular/common/http';
import { Config } from 'app/config.const';
import { Alternativa } from 'app/model/alternativa';
import { Appuntamenti } from 'app/model/appuntamenti';
import { IAppuntamento } from 'app/model/appuntamento';
import { CFID } from 'app/model/id';
import { Impostazioni } from 'app/model/impostazioni_agenda';
import { Paziente } from 'app/model/pazienti';
import { Giorno } from 'app/model/time';
import { SharedUser } from 'app/model/user';
import * as moment from 'moment';
import { Moment } from 'moment';
import { Observable } from 'rxjs/Observable';
import { RESTArray, RESTObject } from '../angular-rest';
import { prepareDataForAuth } from '../../utils';

export interface IAgenda extends CFID {
  personale: boolean;
  codice_fiscale_medico?: string;
}

export class Agenda implements IAgenda {

  public readonly nome: string;
  public readonly codice_fiscale: string;
  public readonly personale: boolean;

  public readonly utenti?: RESTArray<SharedUser>;
  public readonly ambulatorio: Giorno[];
  public readonly alternativa: Alternativa;
  public readonly impostazioni: RESTObject<Impostazioni>;
  public readonly pazienti: RESTArray<Paziente>

  constructor(
    protected readonly $http: HttpClient,
    uri: string,
    initialValue: IAgenda
  ) {

    const {codice_fiscale, nome, personale} = initialValue;
    this.codice_fiscale = codice_fiscale;
    this.nome = nome;
    this.personale = personale;
    this.pazienti = new RESTArray<Paziente>(
      $http,
      `${Config.baseURL}/agende/${codice_fiscale}/pazienti`,
      (h, u, c) => {
        if (c.dataNascita && c.dataNascita.endsWith('Z')) {
          c.dataNascita = moment(c.dataNascita).format('DD/MM/YYYY')
        }
        return new Paziente(h, u, c);
      }
    );

    // FIXME: questo è da fare sempre, non solo per quelle personali,
    // ma visto che parte subito una richiesta http, anche se non serve
    // per ora questo è utile a non ottenere errori spuri.
    if (personale) {
      this.utenti = new RESTArray<SharedUser, SharedUser, any>(
        $http,
        `${uri}/impostazioni/condivisione`,
        (h, u, r) => r,
        t => ({codice_fiscale: t.codice_fiscale}),
        id => id.codice_fiscale
      );
    }


    this.impostazioni = new RESTObject<Impostazioni>($http, `${uri}/impostazioni/generali/`);
    
		const __data = prepareDataForAuth()

    this.ambulatorio = Array.range(7)
      .map(id => new Giorno(
        $http,
        `${uri}/impostazioni/ambulatorio/${id}?__data=${__data}`
      ));

    this.alternativa = new Alternativa($http, `${uri}/impostazioni/ambulatorio`);
  }

  public getEventSocket(from: Moment, to: Moment) {
    return new Appuntamenti(this, from, to);
  }

  public getEventInRange(from: Moment, to: Moment): Observable<IAppuntamento[]> {
    const __data = prepareDataForAuth()

    return this.$http.get<IAppuntamento[]>(
      `${Config.baseURL}/agende/${this.codice_fiscale}/${this.nome}/` +
      `${from.format('YYYY-MM-DD')}/${to.format('YYYY-MM-DD')}/eventi?__data=${__data}`
    );
  }

  public createGroup() {
    return this.$http.post<number>(
      `${Config.baseURL}/nuovo_gruppo`,
      {}
    ).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/model/agenda.ts